import React from 'react';
import { Link } from 'react-router-dom';
export function WaterfordLinks() {
  return <section className="py-12 bg-subtle-gray/30 text-center" data-id="element-3538">
      <div className="max-w-4xl mx-auto px-4" data-id="element-3539">
        <p className="text-gray-warm font-bold mb-4 uppercase tracking-wide" data-id="element-3540">
          Also Serving Nearby Communities
        </p>
        <div className="flex flex-wrap justify-center gap-4" data-id="element-3541">
          {['Commerce', 'West Bloomfield', 'Pontiac', 'Clarkston'].map((area, idx) => <Link key={idx} to={`/${area.toLowerCase().replace(/\s+/g, '-')}-martial-arts`} className="text-ink hover:text-storm-red transition-colors font-medium" data-id="element-3542">
                {area}
              </Link>)}
        </div>
      </div>
    </section>;
}